import { render, staticRenderFns } from "./TreeNav.vue?vue&type=template&id=2be9954e"
import script from "./TreeNav.vue?vue&type=script&lang=js"
export * from "./TreeNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports